<template>
    <div v-if="isAdmin" id="fichebu-priority-management">
        <as-container gutters="0">
            <div class="grid grid-nogutter mb-3">
                <div class="flex w-100">
                    <as-title :title="$t('ficheBu.priority_list.title')" :size="1"></as-title>
                    <div class="ml-auto">
                        <Button style="width: 200px" :label="$t('ficheBu.priority_list.new_priority_button_label')"
                            class="button-default" @click="showModalPriorityForm" />
                    </div>
                </div>
            </div>
            <ProgressBar v-if="isPriorityLoading" mode="indeterminate" style="height: 6px" class="mb-3" />
            <priority-list v-else :priorities="priorities" @onRowClick="editPriority"
                @onDelete="onShowDeletePriorityModal" />
        </as-container>
    </div>
    <as-modal :isVisible="showPriorityForm">
        <priority-form @onClose="closeModalPriorityForm" @onSubmit="savePriority" :isSending="isSending"
            :priority="currentPriority" />
    </as-modal>
    <as-confirm-modal :isVisible="showDeletePriorityModal" :modalMessage="$t('confirm_modal.delete_message')"
        @onConfirm="deletePriority" @onCancel="deletePriorityCancel" />
</template>
<script>
import localeChangeDetectionMixin from "../../mixins/localeChangeDetectionMixins";
import roleMixins from "../../mixins/roleMixins";

import { mapGetters } from "vuex";

import AsTitle from "@/components/Elements/AsTitle.vue";
import AsContainer from "@/components/Containers/AsContainer.vue";
import AsModal from "@/components/Modals/AsModal.vue";
import AsConfirmModal from "@/components/Modals/AsConfirmModal.vue";

import PriorityList from "@/components/FicheBu/PriorityList.vue";
import PriorityForm from "@/components/FicheBu/PriorityForm.vue";

import Button from "primevue/button";
import ProgressBar from "primevue/progressbar";

import { getPriorities, savePriority, deletePriority } from "../../services/priorityServiceApi";
import apiEventTypes from "../../constantes/apiEventTypes";

import moment from "moment"

export default {
    name: "PriorityManagement",
    components: {
        AsTitle,
        AsContainer,
        AsModal,
        AsConfirmModal,
        PriorityList,
        PriorityForm,
        Button,
        ProgressBar,
    },
    data() {
        return {
            isPriorityLoading: true,
            isSending: false,
            showPriorityForm: false,
            currentPriority: { id: 0, libelle: '', sujets: [{ id: 0, libelle: '' }] },
            priorities: [],
            priorityToDeleteId: undefined,
            showDeletePriorityModal: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
    },
    mixins: [localeChangeDetectionMixin, roleMixins],
    beforeMount() {
        if (!this.isAdmin) {
            this.$router.push("/")
        } else {
            this.fetchData()
        }
    },
    methods: {
        async fetchData() {
            this._fetchPriorities()
        },
        showModalPriorityForm() {
            this.currentPriority = { id: 0, libelle: '', sujets: [{ id: 0, libelle: '' }] }
            this.showPriorityForm = true
        },
        closeModalPriorityForm() {
            this.currentPriority = null
            this.showPriorityForm = false
        },
        onShowDeletePriorityModal(priorityId) {
            this.priorityToDeleteId = priorityId;
            this.showDeletePriorityModal = true;
        },
        deletePriorityCancel() {
            this.priorityToDeleteId = undefined;
            this.showDeletePriorityModal = false;
        },

        async editPriority(priority) {
            this.currentPriority = priority
            this.showPriorityForm = true
        },
        async savePriority(data) {
            this.isSending = true
            const payload = JSON.parse(JSON.stringify(data))
            payload.priorityHistory.forEach(e => {
                e.date = moment(e.date).format('YYYY-MM')
            })
            const savedPriority = await savePriority(payload)
            this.isSending = false
            if (savedPriority) {
                this.showPriorityForm = false
                const indexOf = this.priorities.findIndex(e => e.id === savedPriority.id)
                indexOf >= 0 ? this.priorities.splice(indexOf, 1, savedPriority) : this.priorities.push(savedPriority)
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_title"),
                            message: this.$t("popup_messages.success_created_message"),
                        },
                    })
                );
            } else {
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_ERROR, {
                        detail: {
                            title: this.$t("popup_messages.default_error_title"),
                            message: this.$t("popup_messages.default_error_message"),
                        },
                    })
                );
            }
        },
        async deletePriority() {
            if (!this.priorityToDeleteId) { return }
            const result = await deletePriority(this.priorityToDeleteId);
            if (result) {
                const newList = [...this.priorities];
                const indexOf = newList.findIndex((e) => e.id === this.priorityToDeleteId);
                newList.splice(indexOf, 1);
                this.priorities = newList;
                this.deletePriorityCancel()
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_delete_title"),
                            message: this.$t("popup_messages.success_delete_message"),
                        },
                    })
                );
            }
        },
        async _fetchPriorities() {
            this.isPriorityLoading = true
            this.priorities = await getPriorities()
            this.isPriorityLoading = false
        },
    },
};
</script>

<style lang="scss">
#fichebu-priority-management {
    .p-datatable .p-datatable-tbody>tr>td {
        padding: 0.5rem 1rem !important;
    }
}
</style>
